import { SafetyCertificateFilled } from '@ant-design/icons'
import { CSSProperties, FC } from 'react'

type PropType = {
    iconColor?: string
    iconSize?: string
    marginRight?: string
    style?: CSSProperties
}

const SecurePlusIcon: FC<PropType> = props => {
    const { iconColor, iconSize, style, marginRight } = props

    const IconStyle: CSSProperties = {
        color: iconColor || 'white',
        fontSize: iconSize || '12px',
        marginRight: marginRight || '4px',
        ...style,
    }

    return <SafetyCertificateFilled style={IconStyle} />
}

export default SecurePlusIcon
